export const getYears = (count = 5) => {
  const year = new Date().getFullYear();
  const returnArr = [];
  for (let index = 0; index < count; index++) {
    returnArr.push({
      value: year + index, label: year + index
    })
  }
  return returnArr;
};

export const getMonths = () => {
  return [
    { value: 1, label: "January", short:"Jan" },
    { value: 2, label: "February", short:"Feb"  },
    { value: 3, label: "March", short:"Mar"  },
    { value: 4, label: "April", short:"Apr"  },
    { value: 5, label: "May", short:"May"  },
    { value: 6, label: "June", short:"Jun"  },
    { value: 7, label: "July", short:"Jul"  },
    { value: 8, label: "August", short:"Aug"  },
    { value: 9, label: "September", short:"Sep"  },
    { value: 10, label: "October", short:"Oct"  },
    { value: 11, label: "November", short:"Nov"  },
    { value: 12, label: "December", short:"Dec"  },
  ];
};

export const getDays = (maxLength = 31) => {
    var startDate = 1;
    var returnArr = [];
    for (let index = 0; index < maxLength; index++) {
        returnArr.push({value:startDate, label:startDate});
        startDate++;
    }
    return returnArr;
  };